import * as React from "react";
import {Link} from "react-router-dom";
import {getTranslation} from "../../utils/translationUtil";

export interface IAdminClientLinkChipProps {
    clientId: number;
    clientName: string;
}

export const AdminClientLinkChip: React.FunctionComponent<IAdminClientLinkChipProps> = (props: IAdminClientLinkChipProps) => {
    const handleKeyDown = (event: React.KeyboardEvent<HTMLAnchorElement>) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            (event.target as HTMLAnchorElement).click();
        }
    };

    return (
        <Link
            to={`/admin/client/${props.clientId}`}
            className="admin-client-link-chip"
            onKeyDown={handleKeyDown}
            aria-label={getTranslation("admin.navigate-to-client", `Navigate to client ${props.clientName}`)}
            data-testid="admin-client-link-chip"
        >
            <i className="fa-solid fa-building" aria-hidden="true" />
            <span className="admin-client-link-chip__name">{props.clientName}</span>
            <i className="fa-solid fa-arrow-right" aria-hidden="true" />
        </Link>
    );
};
